module.exports = __webpack_public_path__ + "img/profile.64b98cae.jpg";